<template>
  <div media="print">
    <base-button type="submit" class="btn-primary" text="印刷" onclick="window.print(); return false;" />
  </div>
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'PrintButton',
  components: {
    BaseButton,
  }
}
</script>

<style lang="scss">
@import 'scss/print';
</style>